import React, { FC } from 'react';
import PropTypes from 'prop-types';
import { isString } from 'lodash';
import classnames from 'classnames';
import './styles.scss';

export const DescriptionLabel: FC = ({ description, label, className }) => {
  return (
    <div className={classnames('description-item', className)}>
      <div className="description-item__title">{description}</div>

      {isString(label) ? (
        <div className="description-item__label">{label}</div>
      ) : (
        label.map((label, i) => (
          <div className="description-item__label" key={i}>
            {label}
          </div>
        ))
      )}
    </div>
  );
};

DescriptionLabel.propTypes = {
  className: PropTypes.string,
  description: PropTypes.string.isRequired,
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.arrayOf(PropTypes.string)]),
};
